import { hotelesOpciones } from "../../../hook/Arreglos";

/**
 * Componente que muestra una tabla con los eventos asignados.
 * @param {Array} ListaEventoTemporal - Lista temporal de eventos.
 * @param {Function} functions - Función para manejar acciones en los eventos (por ejemplo, eliminar).
 */
export const ListaEventoAsignados = ({ ListaEventoTemporal, functions }) => {
    /**
     * Busca y obtiene el nombre del hotel según su ID.
     * Si no encuentra un hotel, devuelve "No encontrado".
     * @param {number|string} idHotel - ID del hotel.
     * @returns {string} Nombre del hotel o "No encontrado".
     */
    const obtenerNombreHotel = (idHotel) => hotelesOpciones.find((opcion) => opcion.value === idHotel?.toString())?.label || "No encontrado";

    /**
     * Formatea una fecha al formato de 12 horas (AM/PM).
     * Incluye información de día, mes, año y hora.
     * @param {string|Date} fecha - Fecha a formatear.
     * @returns {string} Fecha formateada o "N/D" si no hay fecha.
     */
    const formatearFecha = (fecha) =>
        fecha
            ? new Date(fecha).toLocaleString("es-ES", {
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  weekday: "long",
              })
            : "N/D";

    return (
        <div className="table-card card">
            {/* Encabezado del componente */}
            <div className="d-flex align-items-center justify-content-start py-3 card-header">
                <h5 className="mb-0 me-auto">Lista de Eventos Asignados</h5>
                <p>Aquí están los eventos ya guardados y establecidos en el evento.</p>
            </div>

            {/* Tabla de eventos */}
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table table-hover hoverable-table" id="pc-dt-simple">
                        <thead>
                            <tr>
                                <th>Título</th>
                                <th>Salón</th>
                                <th>Hotel</th>
                                <th>Fecha Hora Inicio</th>
                                <th>Fecha Hora Final</th>
                                <th>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Verifica si hay eventos en la lista temporal */}
                            {ListaEventoTemporal ? (
                                ListaEventoTemporal.slice() // Copia la lista para evitar mutaciones.
                                    .sort((a, b) => {
                                        // Ordena primero por fecha de inicio y luego por fecha final si son iguales.
                                        const startComparison = new Date(a.start) - new Date(b.start);
                                        if (startComparison !== 0) return startComparison;
                                        return new Date(a.end) - new Date(b.end);
                                    })
                                    .map((evento, index) => (
                                        <tr
                                            key={index}
                                            style={{
                                                // Cambia el fondo según el color del evento.
                                                backgroundColor: evento.color === "#349e9e" ? evento.color : "inherit",
                                            }}
                                        >
                                            {/* Datos del evento con estilos dinámicos basados en el color */}
                                            <td style={{ color: evento.color === "#349e9e" ? "#ffffff" : "inherit" }}>{evento.title || "N/A"}</td>
                                            <td style={{ color: evento.color === "#349e9e" ? "#ffffff" : "inherit" }}>{evento.nombreSalon || "N/A"}</td>
                                            <td style={{ color: evento.color === "#349e9e" ? "#ffffff" : "inherit" }}>{obtenerNombreHotel(evento.hotelid)}</td>
                                            <td style={{ color: evento.color === "#349e9e" ? "#ffffff" : "inherit" }}>{formatearFecha(evento.start)}</td>
                                            <td style={{ color: evento.color === "#349e9e" ? "#ffffff" : "inherit" }}>{formatearFecha(evento.end)}</td>
                                            <td>
                                                {/* Botón de acción para eliminar o manejar el evento */}
                                                <a
                                                    className="avtar avtar-xs btn-link-secondary"
                                                    onClick={() => functions(evento.idTemporal)}
                                                    style={{
                                                        color: evento.color === "#349e9e" ? "#ffffff" : "inherit",
                                                    }}
                                                >
                                                    <i className="ti ti-trash f-20"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    ))
                            ) : (
                                // Mensaje mostrado si no hay eventos en la lista.
                                <tr>
                                    <td colSpan="6" style={{ textAlign: "center" }}>
                                        No hay eventos asignados
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
